// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './locales'
import { Button, Row, Col, Card, Form, Input, Switch, DatePicker, Icon, Tabs, Table, Radio, ConfigProvider, Result, Notification, Skeleton, Message, Select } from 'ant-design-vue'
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Form)
Vue.use(Input)
Vue.use(Switch)
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Radio)
Vue.use(ConfigProvider)
Vue.use(Result)
Vue.use(Notification)
Vue.use(Skeleton)
Vue.use(Select)
Vue.config.productionTip = false
Vue.prototype.$message = Message

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js